import capitalize from 'lodash-es/capitalize';
import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.$basename.($storeSlug).deals.$dealId.$slug/route';

const DEFAULT_TITLE =
  'Shop {{ specialName }} products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}';
const DEFAULT_DESCRIPTION = `Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.`;

export const dealDetailRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    rowName: 'Deals',
    specialName: capitalize(data?.currentSpecial?.title),
  });

  return [
    getMetaTitle(customSEO?.deal ?? {}, metaVariables, DEFAULT_TITLE),
    getMetaDescription(
      customSEO?.deal ?? {},
      metaVariables,
      DEFAULT_DESCRIPTION
    ),
    canonicalTag(args.location, menuUrl),
    ...parentMeta(args),
  ];
};
